export function EventError (type = 0) {
  this.name = 'EventError'
  this.stack = (new Error()).stack
  switch (type) {
    case 1:
      this.message = '尚不支援 L0'
      break
    case 2:
      this.message = '此事件已結案'
      break
    default:
      this.message = '無此事件'
      break
  }
}
